import { Component, OnInit, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { ConfigureService } from '@app/configure/services/configure.service';
import { SessionService } from '@app/core/services/session.service';
import { HelperService } from '@app/core/services/helper.service';
import { ModalService } from '@app/core/services/modal.service';

import { Dealer } from '@app/core/models/dealer.model';

@Component({
	selector: 'cng-configure-delivery-options',
	templateUrl: './delivery-options.component.html',
	styleUrls: ['./delivery-options.component.less'],
})
export class ConfigureDeliveryOptionsComponent implements OnInit, OnDestroy {
	current_step_key: string = 'delivery_options';
	dealer: Dealer = this.session_service.getDealer();
	delivery_options: any = this.configure_service.configure_data.steps.delivery_options.data;
	handover_method: 'collection' | 'delivery' = this.getHandoverMethod();
	step_mode: string = this.configure_service.getStepMode();
	delivery_address: string = this.helper_service.buildAddress(
		this.configure_service.getDeliveryAddressAsArray(),
		false
	);
	collection_address: string = this.configure_service.getCollectionAddress() || this.dealer.address;

	destroyed$: Subject<boolean> = new Subject<boolean>();

	/**
	 * Constructs class and injects dependencies.
	 *
	 * @param configure_service
	 * @param session_service
	 * @param skip_finance_service
	 * @param router
	 */
	constructor(
		private configure_service: ConfigureService,
		private session_service: SessionService,
		private helper_service: HelperService,
		private modal_service: ModalService
	) {
		if (!this.configure_service.isStepEnabled('delivery_options')) {
			this.configure_service.navigateToStep('purchase_vehicle');
		}

		this.configure_service.configure_data$.pipe(takeUntil(this.destroyed$)).subscribe((configure_data: any) => {
			this.delivery_options = configure_data.steps.delivery_options.data;
			this.delivery_address = this.helper_service.buildAddress(
				this.configure_service.getDeliveryAddressAsArray(),
				false
			);
			if (this.delivery_options.locked) {
				this.handover_method = this.getHandoverMethod();
			}
			this.collection_address = this.configure_service.getCollectionAddress() || this.dealer.address;
		});
	}

	getHandoverMethod(): 'collection' | 'delivery' {
		if (!this.delivery_options.locked) {
			return this.delivery_options.collection.available ? 'collection' : 'delivery';
		}

		return this.delivery_options.handover.type === 1 ? 'collection' : 'delivery';
	}

	/**
	 * Lifecycle hook: Tracks user activity.
	 */
	ngOnInit(): void {
		this.configure_service.track('step.moved', { step: this.current_step_key }).subscribe();
		this.configure_service.trackJourney().subscribe();
	}

	onHandoverMethodToggle(method: 'collection' | 'delivery'): void {
		this.handover_method = method;
	}

	/**
	 * Jumps to step.
	 *
	 * @param {string} new_step_key
	 */
	jumpTo(new_step_key: string): void {
		this.saveAndGoTo(new_step_key);
	}

	/**
	 * Checks if there are following steps.
	 *
	 * @returns {boolean}
	 */
	hasFollowingSteps(): boolean {
		return this.configure_service.isStepEnabled('payment');
	}

	/**
	 * Navigates to step via configure service.
	 *
	 * @param {string} new_step_key
	 */
	saveAndGoTo(new_step_key: string): void {
		this.configure_service.navigateToStep(new_step_key);
	}

	onContactUs(): void {
		this.modal_service.show(['dealer/contact']);
	}

	ngOnDestroy(): void {
		this.destroyed$.next(true);
	}
}
